export function registerModels(jsonapi, models) {
  let composed
  let meta
  models.forEach((model) => {
    composed = { ...(model.relationships || {}) }
    meta = {}
    // if fields are defined, add fields to composed object
    if (model.fields)
      model.fields.forEach((f) => {
        composed[f] = ''
      })
    // if unformatted is defined, add it to composed object
    if (model.unformatted)
      model.unformatted.forEach((u) => {
        composed[u] = {}
      })
    // if undefined is defined, add it to composed object
    if (model.undefined)
      model.undefined.forEach((u) => {
        composed[u] = null
      })
    // if lists is defined, add it to composed object
    if (model.lists)
      model.lists.forEach((l) => {
        composed[l] = []
      })
    // if collectionPath is defined, add it to meta object
    if (model.collectionPath) meta.collectionPath = model.collectionPath
    // register model on jsonapi object
    jsonapi.define(model.name, composed, meta)
  })
}
